import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

export const MODEL_CAPABILITIES = [
  "image-txt",
  "image-img",
  "texture-txt",
  "texture-img",
  "3d-txt",
  "3d-img",
  "video-txt",
  "video-img",
  "video-video",
] as const;
export type ModelCapability = (typeof MODEL_CAPABILITIES)[number];

export const MODEL_CAPABILITIES_LABELS: {
  [key in ModelCapability]: string;
} = {
  "image-txt": "Text to Image",
  "image-img": "Image to Image",
  "texture-txt": "Text to Texture",
  "texture-img": "Image to Texture",
  "3d-txt": "Text to 3D",
  "3d-img": "Image to 3D",
  "video-txt": "Text to Video",
  "video-img": "Image to Video",
  "video-video": "Video to Video",
} as const;

export const MODEL_CAPABILITIES_VALUES: {
  [key in ModelCapability]: GetModelsByModelIdApiResponse["model"]["capabilities"][number][];
} = {
  "image-txt": ["txt2img", "txt2img_ip_adapter"],
  "image-img": [
    "controlnet",
    "controlnet_img2img",
    "controlnet_inpaint",
    "controlnet_inpaint_ip_adapter",
    "controlnet_ip_adapter",
    "controlnet_reference",
    "img2img",
    "img2img_ip_adapter",
    "inpaint",
    "inpaint_ip_adapter",
    "outpaint",
    "reference",
  ],
  "texture-txt": ["txt2img_texture"],
  "texture-img": ["img2img_texture", "controlnet_texture", "reference_texture"],
  "3d-txt": ["txt23d"],
  "3d-img": ["img23d"],
  "video-txt": ["txt2video"],
  "video-img": ["img2video"],
  "video-video": ["video2video"],
} as const;
